import { render } from "./ChooseProductModal.vue?vue&type=template&id=65a4cc44&scoped=true"
import script from "./ChooseProductModal.vue?vue&type=script&lang=js"
export * from "./ChooseProductModal.vue?vue&type=script&lang=js"

import "./ChooseProductModal.vue?vue&type=style&index=0&id=65a4cc44&lang=scss&scoped=true"
import "./ChooseProductModal.vue?vue&type=style&index=1&id=65a4cc44&lang=scss"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a4cc44"]])

export default __exports__